import { Coordinates } from '../types/Coordinates';

export const getGoogleMapsUrl = (address: string, { lat, lon }: Coordinates) =>
  `https://www.google.com/maps/dir//${encodeURIComponent(
    address,
  )}/@${lat},${lon},14z/data=!4m2!4m1!3e0`;
